import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { finalize, map, Observable } from 'rxjs';

import { Country } from '@shared/models';

import { BaseService } from '../base.service';
import { LoadersService } from '../loaders.service';

@Injectable({
  providedIn: 'root',
})
export class CountriesService extends BaseService {
  constructor(
    private http: HttpClient,
    private loadersService: LoadersService
  ) {
    super();
  }

  getAll(loader: string): Observable<Array<Country>> {
    this.loadersService.show(loader);
    return this.http
      .get<Array<Country>>(`${this.baseUrl}/countries`)
      .pipe(finalize(() => this.loadersService.hide(loader)));
  }

  getById(id: string, loader: string): Observable<Country> {
    this.loadersService.show(loader);
    return this.http
      .get<Country>(`${this.baseUrl}/countries/${id}`)
      .pipe(finalize(() => this.loadersService.hide(loader)));
  }

  edit(dto: Country, loader: string): Observable<boolean> {
    this.loadersService.show(loader);
    return this.http.put(this.baseUrl + '/countries', dto, { observe: 'response' }).pipe(
      map((response) => this.isStatusSucceed(response.status)),
      finalize(() => this.loadersService.hide(loader))
    );
  }
}
